'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepAssign = deepAssign;
exports.deepExtract = deepExtract;

var _verify = require('./verify');

function deepAssign(path, base, value) {
  if (path === '') {
    throw new Error('Cannot assign with empty path');
  }

  var levels = path.split(/\./);
  var final = levels.pop();

  var current = levels.reduce(function (visitor, level, idx) {
    if (!(0, _verify.isObject)(visitor)) {
      throw new Error('Cannot traverse past ' + levels.slice(0, idx).join('.'));
    }
    return visitor[level] = visitor[level] || {};
  }, base);

  return current[final] = value;
}

function deepExtract(path, base, defaultValue) {
  var result = path === '' ? base : path.split(/\./).reduce(function (visitor, level) {
    return (0, _verify.isObject)(visitor) ? visitor[level] : undefined;
  }, base);
  return (0, _verify.isDefined)(result) ? result : defaultValue;
}